export default "__VITE_ASSET__mWaGlnvL__"